export default "__VITE_ASSET__C2D$VxNR__"